import React from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import SidePopup from '../../SidePopup'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'

const BrandView = (props) => {
  const brand = Object.values(props.brands).filter((b) => props.match.params.id === b._id)[0]

  const hideModal = (e) => {
    if (e) e.preventDefault()
    props.history.goBack()
  }

  const handleEdit = () => {
    const url = props.match.url
    props.history.push(`${url}/edit`)
  }

  const { capabilities, user } = props

  let userCanManageBrand = userIsAuthorized({ capability: capabilities.brands, action: 'UPDATE' })

  if (user.role === 'brandManager') {
    user.brands.forEach((userBrand) => {
      if (userBrand.id === brand._id) {
        userCanManageBrand = true
      }
    })
  }

  return (
    <SidePopup onHide={hideModal}>
      <Container>
        <Row>
          <Col xs={12}>
            <div className='section-title'>{brand.name}</div>
          </Col>
        </Row>
        <Row className='no-gutters mt-3'>
          {userCanManageBrand && (
            <Col className='text-right'>
              <Button onClick={handleEdit} color='primary'>
                {I18n.t('dashboard_edit')}
              </Button>
            </Col>
          )}
        </Row>
      </Container>
    </SidePopup>
  )
}

export default connect((state) => ({ brands: state.brands, user: state.user }))(withRouter(BrandView))
